import { connectState, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateBase } from '../../store/baseStore';

import * as S from './styles'
import Loading from './loading';
import Error from './error';
import { Either } from '../../utils/propsUtil';
import Sucess from './success/success';

const connector = connectState(
  (state: RootStateBase) => ({
    loading: state.BaseReducer.Loading,
    error: state.BaseReducer.Error,
    success: state.BaseReducer.Success,
  })
);

interface Props0 extends PropsFromRedux<typeof connector> {
    stateLoadingNames?: string[]
    stateErrorNames?: string[]
    stateSucessNames?: string[]
}

interface Props1 {
    //   stateLoadingNames: string[]
}

interface Props2 {
    // stateErrorNames: string[]
}

export type StateMensageProps = Props0 & Either<Props1, Props2>;


function StateMensage(props: StateMensageProps){
    return (
        <S.StateMensage>
            {props.stateLoadingNames != null && props.loading.find((e) => props.stateLoadingNames != null && props.stateLoadingNames.includes(e.Name)) &&
                <Loading stateNames={props.stateLoadingNames} />
            }
            {props.stateErrorNames != null && props.error.find((e) => props.stateErrorNames != null && props.stateErrorNames.includes(e.Name)) &&
                <Error stateNames={props.stateErrorNames} />
            }
            {props.stateSucessNames != null && props.success.find((e) => props.stateSucessNames != null && props.stateSucessNames.includes(e.Name)) &&
                <Sucess stateNames={props.stateSucessNames} />
            }
        </S.StateMensage>
    );
}

export default connector(StateMensage);
